// Mirrors ReceiptType on the backend (Order.Models). Discriminates a provider receipt "Pre-Invoice".
export enum ReceiptType {
  // Provider-issued fiscal document — carries providerInvoiceNumber + fiscalInvoiceNumber.
  Fiscal = 0,
  // Self-issued (vendor not SAR-registered). No provider/fiscal number until the ApDocument is created.
  Purchase = 1,
}
